// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Account: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 42 42">
            <g fill="none" fillRule="evenodd">
                <path
                    fill="currentColor"
                    d="M20.88 7.14c-3.639 0-6.6 2.96-6.6 6.599 0 3.636 2.961 6.596 6.6 6.596 3.638 0 6.599-2.96 6.599-6.596a6.607 6.607 0 0 0-6.599-6.6m0 10.709a4.116 4.116 0 0 1-4.113-4.11 4.117 4.117 0 0 1 4.113-4.111 4.116 4.116 0 0 1 4.112 4.112 4.116 4.116 0 0 1-4.112 4.109"
                />
                <path
                    fill="currentColor"
                    d="M20.88 0C9.367 0 0 9.367 0 20.88c0 11.512 9.367 20.876 20.88 20.876 11.512 0 20.876-9.364 20.876-20.876C41.756 9.367 32.392 0 20.88 0Zm11.807 35.048a17.39 17.39 0 0 1-11.807 4.615 17.393 17.393 0 0 1-11.808-4.615l-.238-.22.076-.307a12.298 12.298 0 0 1 11.97-9.347c3.288 0 6.387 1.282 8.728 3.613a12.222 12.222 0 0 1 3.237 5.734l.077.308-.235.219Zm2.831-3.06-.57.752-.36-.874a14.787 14.787 0 0 0-3.229-4.838 14.712 14.712 0 0 0-10.479-4.341c-6.047 0-11.424 3.606-13.699 9.185l-.357.878-.576-.752A18.193 18.193 0 0 1 2.486 20.88c0-10.142 8.252-18.393 18.394-18.393 10.142 0 18.393 8.25 18.393 18.393 0 4.039-1.298 7.88-3.755 11.108Z"
                />
            </g>
        </svg>
    );
};

export default React.memo(Account);
